<template>
  <div class="contacts">
    <transition name="contact-page" mode="out-in">
      <div class="contacts-view padding-bot" v-if="!activeCall" key="contacts">
        <contact-list
          :contacts="contacts"
          :call-loading="isCallLoading"
          @call="onCall"
        />
        <create-contact-form
          :is-contacts-loading="isLoading"
          :show-label="!contacts.length"
          @autoConnect="onAutoConnect"
        />
      </div>
      <div class="contacts-view" key="call" v-else>
        <call-session :call-sid="callSid" :call="activeCall" @disconnected="hangUp"/>
      </div>
    </transition>
    <transition name="hang-up">
      <hang-up-button v-if="activeCall" :call="activeCall" :hang-up-loading="isHangUpLoading" @click.native="hangUp"/>
    </transition>
    <error-msg-box v-if="errorMicrophoneAccess" @click.native="testMicrophoneAccess"/>
    <transition name="vi-modal">
      <create-note v-if="currentNote" :current-note="currentNote"/>
    </transition>
  </div>
</template>

<script>
  import AddContactButton from "../components/contacts/AddContactButton";
  import CreateContactForm from "../components/contacts/CreateContactForm";
  import ContactList from "../components/contacts/ContactList";
  import {mapState} from 'vuex';
  import CallSession from "../components/call/CallSession";
  import HangUpButton from "../components/call/HangUpButton";
  import {completeRoom} from "../services/apollo/call";
  import ErrorMsgBox from "../components/call/ErrorMsgBox";
  import CreateNote from "../components/notes/CreateNote";

  export default {
    name: "Contacts",
    components: {CreateNote, ErrorMsgBox, HangUpButton, CallSession, ContactList, CreateContactForm, AddContactButton},
    props: {
      callSid: {
        type: String
      }
    },

    data: () => ({
      isCallLoading: null,
      isHangUpLoading: false,
      errorMicrophoneAccess: false,
      isLoading: true
    }),

    computed: {
      ...mapState({
        activeCalls: state => state.call.activeCalls,
        contacts: state => state.contacts.contacts,
        currentNote: state => state.notes.currentNote
      }),
      activeCall() {
        return this.activeCalls[this.callSid]
      },
    },

    methods: {
      onCall({contact, shouldRecord}) {
        this.isCallLoading = contact.identity;
        this.$store.dispatch('call/startCall', {contact, shouldRecord})
          .then(callSid => {

            this.isCallLoading = null;
            this.$router.push({
              name: 'ContactActiveCall',
              params: {
                callSid
              }
            })
          })
          .catch(err => {
            this.isCallLoading = null;
            this.error = err.message
          })
      },

      onAutoConnect({contact, room, shouldRecord}) {
        console.log(contact, room)
        this.$store.dispatch('call/autoConnectToCall', {contact, room: room.room, call: room.call, shouldRecord})
        this.$router.push({
          name: 'ContactActiveCall',
          params: {
            callSid: room.call.callSid
          }
        })
      },

      hangUp() {
        if (this.isHangUpLoading) {
          return;
        }
        this.isHangUpLoading = true;
        completeRoom(this.activeCall.room.roomId)
          .catch(() => {
            this.isHangUpLoading = false;
          })
          .then(() => {
            this.$store.commit('global/setCallsInProgress', false)
            this.isHangUpLoading = false;
            this.$router.push({
              name: 'Contacts'
            })
          });
      },
      testMicrophoneAccess() {
        navigator.mediaDevices.getUserMedia({audio: true})
          .then((stream) => {
            this.$store.commit('global/setAppError', false);
            this.errorMicrophoneAccess = false;
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
          })
          .catch(() => {
            this.errorMicrophoneAccess = true;
            this.$store.commit('global/setAppError', true)
          })
      }
    },

    mounted() {
      navigator.mediaDevices.ondevicechange = function (event) {

      }
    },

    created() {
      this.$store.dispatch('contacts/list')
        .then(() =>  {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false
        });
      this.$store.dispatch('sessions/listCallsInProgress');
      this.testMicrophoneAccess()
    }
  }
</script>

<style lang="scss">
  @import "Contacts";
</style>
